import React, { useState } from 'react';
import { Room } from '../types/Room';
import { MoreHorizontalIcon, PlusIcon, EditIcon, ImageIcon, TrashIcon } from 'lucide-react';
export function Rooms() {
  // Mock data based on the screenshot
  const [rooms, setRooms] = useState<Room[]>([{
    id: '1',
    name: 'Scuba Spa Test',
    code: 'Scuba Spa Test',
    category: 'SUPERIOR',
    status: 'inactive',
    image: ''
  }, {
    id: '2',
    name: 'Deluxe Beach Villa',
    code: 'DBV',
    category: 'DELUXE',
    status: 'inactive',
    image: ''
  }, {
    id: '3',
    name: 'Water Villa',
    code: 'SUNSIYAMEX',
    category: 'OVERWATER_VILLA',
    status: 'active',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f8LmzsSdSzWEQ5tecvvWgQ/Screenshot_2025-10-01_at_10.57.35_AM.png'
  }, {
    id: '4',
    name: 'Premium Overwater Villa',
    code: 'POWVDTAC',
    category: 'OVERWATER_VILLA',
    status: 'active',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVQhnbj3swJxvFUYQfTssC/Screenshot_2025-10-01_at_10.57.42_AM.png'
  }]);
  // Filter state
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [categoryFilter, setCategoryFilter] = useState<string>('all');
  // Action menu state
  const [actionMenuOpen, setActionMenuOpen] = useState<string | null>(null);
  // Filter rooms based on search term and filters
  const filteredRooms = rooms.filter(room => {
    const matchesSearch = room.name.toLowerCase().includes(searchTerm.toLowerCase()) || room.code.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || statusFilter === 'active' && room.status === 'active' || statusFilter === 'inactive' && room.status === 'inactive';
    const matchesCategory = categoryFilter === 'all' || formatCategoryName(room.category) === categoryFilter;
    return matchesSearch && matchesStatus && matchesCategory;
  });
  // Format category name for display
  function formatCategoryName(category: string): string {
    return category.replace('_', ' ');
  }
  // Navigate to add room page
  const navigateToAddRoom = () => {
    window.location.href = '/add-room';
  };
  // Navigate to edit room page
  const navigateToEditRoom = (roomId: string) => {
    window.location.href = `/edit-room?id=${roomId}`;
  };
  // Navigate to room assets page
  const navigateToRoomAssets = (roomId: string) => {
    window.location.href = `/room-detail?id=${roomId}`;
  };
  // Delete room
  const deleteRoom = (roomId: string) => {
    if (confirm('Are you sure you want to delete this room?')) {
      setRooms(rooms.filter(room => room.id !== roomId));
    }
  };
  // Toggle action menu
  const toggleActionMenu = (roomId: string) => {
    if (actionMenuOpen === roomId) {
      setActionMenuOpen(null);
    } else {
      setActionMenuOpen(roomId);
    }
  };
  return <div className="space-y-6" data-id="element-10488">
      <div className="flex justify-between items-center" data-id="element-10489">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-10490">Rooms</h1>
        <button onClick={navigateToAddRoom} className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center" data-id="element-10491">
          <PlusIcon size={18} className="mr-1" data-id="element-10492" />
          Add Room
        </button>
      </div>
      {/* Filters */}
      <div className="flex flex-wrap gap-3" data-id="element-10493">
        <input type="text" placeholder="Search rooms..." className="border border-gray-300 rounded-md px-3 py-2 w-48" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-10494" />
        <select className="border border-gray-300 rounded-md px-3 py-2" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-10495">
          <option value="all" data-id="element-10496">Status</option>
          <option value="active" data-id="element-10497">Active</option>
          <option value="inactive" data-id="element-10498">Inactive</option>
        </select>
        <select className="border border-gray-300 rounded-md px-3 py-2" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} data-id="element-10499">
          <option value="all" data-id="element-10500">Room Category</option>
          <option value="SUPERIOR" data-id="element-10501">Superior</option>
          <option value="DELUXE" data-id="element-10502">Deluxe</option>
          <option value="OVERWATER VILLA" data-id="element-10503">Overwater Villa</option>
        </select>
      </div>
      {/* Room List */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-10504">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-10505">
          <thead className="bg-gray-50" data-id="element-10506">
            <tr data-id="element-10507">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10508">
                Room image
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10509">
                Room name
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10510">
                Room category
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10511">
                Room code
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10512">
                Status
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10513">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-10514">
            {filteredRooms.map(room => <tr key={room.id} data-id="element-10515">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-10516">
                  {room.image ? <img src={room.image} alt={room.name} className="h-16 w-24 object-cover rounded" data-id="element-10517" /> : <div className="h-16 w-24 bg-gray-100 flex items-center justify-center text-gray-400 text-xs rounded" data-id="element-10518">
                      No image
                    </div>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-10519">
                  <div className="text-sm font-medium text-gray-900" data-id="element-10520">
                    {room.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-10521">{room.code}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-10522">
                  <div className="text-sm text-gray-900" data-id="element-10523">
                    {formatCategoryName(room.category)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-10524">
                  <div className="text-sm text-gray-900" data-id="element-10525">{room.code}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-10526">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${room.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-10527">
                    {room.status === 'active' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium relative" data-id="element-10528">
                  <button className="text-gray-400 hover:text-gray-500" onClick={() => toggleActionMenu(room.id)} data-id="element-10529">
                    <MoreHorizontalIcon size={18} data-id="element-10530" />
                  </button>
                  {actionMenuOpen === room.id && <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-10531">
                      <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-10532">
                        <button onClick={() => {
                    setActionMenuOpen(null);
                    navigateToEditRoom(room.id);
                  }} className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left" data-id="element-10533">
                          <EditIcon size={16} className="mr-2" data-id="element-10534" />
                          Edit
                        </button>
                        <button onClick={() => {
                    setActionMenuOpen(null);
                    navigateToRoomAssets(room.id);
                  }} className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left" data-id="element-10535">
                          <ImageIcon size={16} className="mr-2" data-id="element-10536" />
                          Manage Images
                        </button>
                        <button onClick={() => {
                    setActionMenuOpen(null);
                    deleteRoom(room.id);
                  }} className="flex items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100 w-full text-left" data-id="element-10537">
                          <TrashIcon size={16} className="mr-2" data-id="element-10538" />
                          Delete
                        </button>
                      </div>
                    </div>}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}